/*
 * @Author: lzy
 * @Date: 2021-03-09 10:11:08
 * @LastEditTime: 2021-04-27 10:49:50
 * @LastEditors: lzy
 * @Description: 多渠道稿件组件
 * @FilePath: \xjmediacloud\app\editingCenter\directive\multichannelManuscripts\multichannelManuscripts.js
 */

angular.module('multichannelManuscriptsModult', []).directive('multichannelManuscripts', ['trsHttpService', 'editingCenterService', 'mediaIconObj',
    function(trsHttpService, editingCenterService, mediaIconObj) {
        return {
            replace: true,
            restrict: 'E',
            transclude: false,
            scope: {
                metadataId: '@'
            },
            templateUrl: './editingCenter/directive/multichannelManuscripts/index.html',
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        manuscripts: [],
                        icons: mediaIconObj.iconObj
                    };
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 0
                    };
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    requestData();
                }

                $scope.pageChanged = requestData;

                /**
                 * [requestData description] 请求列表
                 *
                 * @return  {[type]}   [return description]
                 */
                function requestData() {
                    const params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'querySameSourceDoc',
                        MetaDataId: $scope.metadataId,
                        PageSize: $scope.page.PAGESIZE,
                        CurrPage: $scope.page.CURRPAGE
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.manuscripts = data.DATA;
                        $scope.page = data.PAGER;
                    });
                }
                // 获取渠道中文名
                $scope.getMediaName = editingCenterService.getMediaName;
                // 跳转到稿件详情页
                $scope.routerToDetail = editingCenterService.routerToPreview;
            }
        };
    }
]);
